// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__35sOx","disabled":"Button_disabled__1lTL1","button-text":"Button_button-text__3lIbH"};